var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"Calendar-nav"},[_c('a-icon-button',{attrs:{"icon":"arrow_back","tag":"li","to":_vm.prevLink}},[_vm._v("Prev")]),_vm._v(" "),_c('a-button',{attrs:{"tag":"li","to":_vm.todayLink}},[_vm._v(_vm._s(_vm.todayText))]),_vm._v(" "),_c('a-icon-button',{attrs:{"icon":"arrow_forward","tag":"li","to":_vm.nextLink}},[_vm._v("Next")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa8788a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarNav.vue
// module id = 181
// module chunks = 0